define(function(){
    var Backbone = require('backbone');
    const builder = require('civicsUtils/buildUrlParameters');
	const IpsModel = require('civicsBase/ipsModel');
    const IpsModelCollection = require('civicsBase/ipsModelCollection');
    return IpsModelCollection.extend({
        model: IpsModel,
        urlRoot:'/delegate/civics-api/api/resources/contacts/serviceproviders',
        urlAttributes: null,
        url: function() {
            if(this.urlAttributes &&
               typeof this.urlAttributes.instrumentType !== 'undefined' &&
               typeof this.urlAttributes.assignmentType !== 'undefined' &&
               typeof this.urlAttributes.assignmentCode !== 'undefined') {
                return this.urlRoot + '?Type=' + this.urlAttributes.instrumentType +
            			'&' + this.urlAttributes.assignmentType + '=' + this.urlAttributes.assignmentCode;
	        }
        return '';
        }
    });
});
